import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import { Carousel } from "@fancyapps/ui/dist/carousel/carousel.esm.js";
import "@fancyapps/ui/dist/carousel/carousel.css";
import { Autoplay } from "@fancyapps/ui/dist/carousel/carousel.autoplay.esm.js";
import "@fancyapps/ui/dist/carousel/carousel.autoplay.css";
import { Thumbs } from "@fancyapps/ui/dist/carousel/carousel.thumbs.esm.js";
import "@fancyapps/ui/dist/carousel/carousel.thumbs.css";

// import { Panzoom } from "@fancyapps/ui/dist/panzoom/panzoom.esm.js";
// import "@fancyapps/ui/dist/panzoom/panzoom.css";

export {
   Fancybox,
   Carousel,
   Autoplay,
   Thumbs,
   // Panzoom
}

document.addEventListener("DOMContentLoaded", function () {
   Fancybox.bind('[data-fancybox]', {
      // opções
   });

   Fancybox.bind('[data-fancybox="gallery"]', {
      // Your custom options for a specific gallery
   });
});